import { getJson } from "../../auth/utils/getJson.js";  
import { apiFetch } from "../../auth/api/apiFetch.js"; 

/** GET /api/units */
export function fetchUnits(signal) {
  return getJson("/api/units", { signal }).then((json) =>
    Array.isArray(json) ? json : []
  );
}

/** POST /api/units/modify */
export async function modifyUnit({ unitName, effectiveFrom, stoodDown, user, filename }, signal) {
  const res = await apiFetch("/api/units/modify", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ unitName, effectiveFrom, stoodDown, user, filename }),
    signal,
  });

  const text = await res.text().catch(() => "");
  if (!res.ok) {
    try {
      const json = JSON.parse(text);
      throw new Error(json?.error || text || `Request failed (HTTP ${res.status})`);
    } catch {
      throw new Error(text || `Request failed (HTTP ${res.status})`);
    }
  }
  try { return text ? JSON.parse(text) : {}; } catch { return {}; }
}

/** GET /api/units/:unitName */
export function fetchUnitDetails(unitName, signal) {
  const encoded = encodeURIComponent(unitName);
  return getJson(`/api/units/${encoded}`, { signal });
}

/** GET /api/units/:unitName/meters */
export function fetchUnitMeters(unitName, signal) {
  const encoded = encodeURIComponent(unitName);
  return getJson(`/api/units/${encoded}/meters`, { signal })
    .then((json) => (Array.isArray(json) ? json : []));
}

/** GET /api/units/:unitName/files */
export function fetchUnitFiles(unitName, signal) {
  const encoded = encodeURIComponent(unitName);
  return getJson(`/api/units/${encoded}/files`, { signal })
    .then((json) => (Array.isArray(json) ? json : []));
}

/** GET /api/units/:unitName/versions */
export function fetchUnitVersions(unitName, signal) {
  const encoded = encodeURIComponent(unitName);
  return getJson(`/api/units/${encoded}/versions`, { signal })
    .then((json) => (Array.isArray(json) ? json : []));
}

/** GET /api/energy/summary?meter=...&train=...&operator=...&from=...&to=... */
export function fetchEnergySummary({ meter, train, operator, from, to }, signal) {
  const qs = new URLSearchParams();
  if (meter) qs.set("meter", meter);
  if (train) qs.set("train", train);
  if (operator) qs.set("operator", operator);
  if (from) qs.set("from", from);
  if (to) qs.set("to", to);
  return getJson(`/api/energy/summary?${qs.toString()}`, { signal });
}
